import { Breadcrumb, Button, Modal } from 'react-bootstrap';
import { useState, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import '../App.css';
import HelpButton from "./HelpButton";

/* 저택 내부 inside의 root */
function Page6() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState("마당");
  const [showBasementModal, setShowBasementModal] = useState(false);

  const [pages, setPages] = useState([
    {name: "마당", path: "yard"}, 
    {name: "거실", path: "living"},
    {name: "주방", path: "kitchen"},
    {name: "침실", path: "bedroom"}, 
    {name: "서재", path: "study"}]);

  const currentPath = location.pathname.split('/').pop(); // 예: "yard", "study", "basement"
  const showHint = currentPath === "study";

  const handlePageClick = (page) => {
    setSelected(page.name);
    navigate(`/inside/${page.path}`, { replace: false });
  };

  const handleLeftClick = () => {
    if (currentPath === "bedroom") {
      setShowBasementModal(true);
    } else {
      alert('더 갈 곳이 없다');
    }
  };

  const handleRightClick = () => {
      alert('더 갈 곳이 없다');
  };

  const handleGoToBasement = () => {
    const basementPage = { name: "???", path: "basement" };

    if (!pages.some(p => p.path === "basement")) {
      setPages(prev => [...prev, basementPage]);
    }

    setShowBasementModal(false);
    setSelected("???");
    navigate("/inside/basement");
  };


  useEffect(() => {
    if (location.state?.fromCoffin) {
      setSelected("침실");
    }
  }, [location.state]);

  useEffect(() => {
  const path = location.pathname.split('/').pop();
  const matched = pages.find(p => p.path === path);
  if (matched) {
    setSelected(matched.name);
  }
}, [location.pathname, pages]);


  return (

    <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            alert('아직 길드장님을 만나지 못했다');
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/mansion' }}>
          저택
        </Breadcrumb.Item>
        <Breadcrumb.Item active>내부</Breadcrumb.Item>
      </Breadcrumb>
      {/* 오른쪽 상단 버튼 */}
        <HelpButton showHint = {showHint} />
        </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start">
        {selected === "???" ? (
          <>
          <p>계단 끝에는 문이 보인다. 문 너머는 캄캄하다</p>
          <p>... 들어가도 될지 모르겠다</p>
          </>
        ) : (
          <p>넓다. 어디를 둘러보지?</p>
        )}
      </div>
      <br/>

      <div className="d-flex justify-content-center mt-3" style={{ userSelect: 'none', pointerEvents: 'auto', position: 'relative', zIndex: 10 }}>
        <nav aria-label="Room navigation">
          <ul className='pagination'>
         
        {/* 이전 버튼 */}
      <li className="page-item">
        <button className="page-link" onClick={handleLeftClick} aria-label="Previous"             style={{fontSize: '80%' }}
>
          <span aria-hidden="true">&laquo;</span>
        </button>
      </li>

      {/* 공간 목록 버튼 */}
      {pages.map((page) => (
        <li key={page.path} className={`page-item ${selected === page.name ? 'active' : ''}`}>
          <button
      className="page-link"
      style={{ fontSize: '80%' }}
      onClick={() => handlePageClick(page)}
    >
      {page.name}
    </button>
        </li>
      ))}

      {/* 다음 버튼 */}
        <li className="page-item">
        <button className="page-link" onClick={handleRightClick} aria-label="Next"             style={{fontSize: '80%' }}
>
          <span aria-hidden="true">&raquo;</span>
        </button>
      </li>
           </ul>
        </nav>

    </div>

    <div style={{marginTop: '3vh'}}>
       <Outlet key={location.key} />
    </div>

      <Modal show={showBasementModal} onHide={() => setShowBasementModal(false)} centered>
  <Modal.Body className="text-center">
    <p>침대 밑에 계단이 숨겨져있다. 내려가볼까?</p>
  </Modal.Body>
  <Modal.Footer className="justify-content-center" style={{ borderTop: 'none'}}>
    <Button variant="primary" onClick={handleGoToBasement}>
      내려가기
    </Button>
  </Modal.Footer>
</Modal>


    </div>
  );
}

export default Page6;
